export * from './select-tramite.service';
export * from './cpt-form.service';
export * from './process-automation.service';
export * from './storage.service';



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/shared/index.ts